<template>
  <p class="padding">Depending on your payment status your order will be processed.</p>
</template>

<script>
export default {

}
</script>

<style>

</style>